import { jsx as b } from "react/jsx-runtime";
import { IressTableFormattedValue as o } from "../TableFormattedValue/TableFormattedValue.js";
import { formatObjectKey as g } from "../../../helpers/formatting/formatObjectKey.js";
import { getFormatFromValue as d } from "./getFormatFromValue.js";
import { b as F } from "../../../index-CmsyHM_3.js";
const h = (p, a) => {
  const s = F();
  return a ? (Array.isArray(a) ? a.map((e) => [
    e.key,
    e
  ]) : Object.entries(a)).map(([e, r]) => {
    const f = !!(r != null && r.sort) || !!(r != null && r.sortFn), i = {
      id: e,
      cell: (t) => /* @__PURE__ */ b(
        o,
        {
          currencyCode: r == null ? void 0 : r.currencyCode,
          format: (r == null ? void 0 : r.format) ?? d(t.getValue()),
          value: t.getValue(),
          row: t.row.original
        }
      ),
      header: () => r == null ? void 0 : r.label,
      enableSorting: f
    };
    return r != null && r.sortFn && (i.sortingFn = r.sortFn), s.accessor(
      (t) => t[e],
      i
      // The typing is weird, cannot get it to work without the never cast, its typed properly above anyway
    );
  }) : Object.keys(p[0] ?? {}).map(
    (e) => s.accessor((r) => r[e], {
      id: e,
      cell: (r) => r.getValue(),
      header: () => g(e),
      enableSorting: !1
    })
  );
};
export {
  h as composeIDSTableColumnDefs
};
